import React, {useCallback} from 'react'
import Typography from '@material-ui/core/Typography';
import {useDropzone} from 'react-dropzone'
import {DropZoneContainer} from './styled'

const loadFile = (file: File) => new Promise<string | ArrayBuffer | null>(resolve => {
  const reader = new FileReader();
  reader.addEventListener('loadend', () => resolve(reader.result));
  reader.readAsArrayBuffer(file)
});

type DropzoneProps = {
  onLoaded(data: ArrayBuffer): void;
  accept?: string;
}

export const Dropzone = ({ onLoaded, accept }: DropzoneProps) => {
  const onDrop = useCallback((acceptedFiles: File[]) => {
    const firstFile = acceptedFiles[0];
    loadFile(firstFile).then((arrayBuffer) => {
      onLoaded(arrayBuffer as ArrayBuffer)
    })
  }, [onLoaded])

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    multiple: false,
    onDrop,
    accept: accept ?? undefined
  })

  return (
    <DropZoneContainer
      {...getRootProps()}
      isActive={isDragActive}
    >
      <input {...getInputProps()} />
      {
        isDragActive ?
          <Typography>Drop the files here ...</Typography> :
          <Typography>Drag and drop the file, or click to select</Typography>
      }
    </DropZoneContainer>
  )
}
